export default __webpack_public_path__ + "static/media/FlechaHorizontal.66e9071f.svg";